export default {
    findUserTeachers:      { method: 'get',    url: 'user_teachers' },
    createUserTeacher:     { method: 'post',   url: 'user_teachers' },
    updateUserTeacher:     { method: 'put',    url: 'user_teachers/{id}' },
    deleteUserTeacher:     { method: 'delete', url: 'user_teachers/{id}' },
}
